export default __webpack_public_path__ + "static/media/ic_yellow_star.ca9bae27.svg";